import { URL_PATH_CDN } from '../constants/urls';
import { IIndexable } from '../model/IIndexable';
import { ResultadoData } from '../model/ResultadoData';
import { productoDataMapping } from './productoDataMapping';

export function resultadoDataMapping(item: IIndexable) {
  const products = item?.products?.map?.((prod: IIndexable) => productoDataMapping(prod));

  const commentsUrl = item?.comments ? `${URL_PATH_CDN}${item?.comments}` : '';

  return new ResultadoData(products, item?.title, item?.icon, commentsUrl);
}
